var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmployerSearchCandidatesIconBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.4 8.08333C0.4 12.0443 3.62235 15.2667 7.58333 15.2667C11.5443 15.2667 14.7667 12.0443 14.7667 8.08333C14.7667 4.12235 11.5443 0.9 7.58333 0.9C3.62235 0.9 0.4 4.12235 0.4 8.08333ZM1.30833 8.08333C1.30833 4.6231 4.1231 1.80833 7.58333 1.80833C11.0436 1.80833 13.8583 4.6231 13.8583 8.08333C13.8583 11.5436 11.0436 14.3583 7.58333 14.3583C4.1231 14.3583 1.30833 11.5436 1.30833 8.08333Z",
    fill: "#2667B0",
    stroke: "#2667B0",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8246 17.9673L16.825 17.9677C16.9137 18.0555 17.0299 18.1 17.1461 18.1C17.2622 18.1 17.3786 18.0556 17.4669 17.9673C17.644 17.7902 17.644 17.5023 17.4669 17.3251L12.6644 12.5226C12.4872 12.3455 12.1993 12.3455 12.0221 12.5226C11.845 12.6998 11.845 12.9877 12.0221 13.1648L16.8246 17.9673Z",
    fill: "#2667B0",
    stroke: "#2667B0",
    strokeWidth: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.35898 5.25C5.35898 6.47681 6.35717 7.475 7.58398 7.475C8.8108 7.475 9.80898 6.47681 9.80898 5.25C9.80898 4.02319 8.8108 3.025 7.58398 3.025C6.35717 3.025 5.35898 4.02319 5.35898 5.25ZM6.26732 5.25C6.26732 4.52394 6.85792 3.93333 7.58398 3.93333C8.31005 3.93333 8.90065 4.52394 8.90065 5.25C8.90065 5.97606 8.31005 6.56667 7.58398 6.56667C6.85792 6.56667 6.26732 5.97606 6.26732 5.25Z",
    fill: "#2667B0",
    stroke: "#2667B0",
    strokeWidth: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.317 11.271C10.317 11.5217 10.5204 11.7252 10.7712 11.7252C11.0219 11.7252 11.2253 11.5217 11.2253 11.271V10.0123C11.2253 8.89846 10.3606 7.9835 9.2872 7.9835H5.88083C4.80679 7.9835 3.94199 8.89843 3.94199 10.0123V11.271C3.94199 11.5217 4.14543 11.7252 4.39616 11.7252C4.64689 11.7252 4.85033 11.5217 4.85033 11.271V10.0123C4.85033 9.38658 5.31976 8.89183 5.88083 8.89183H9.28649C9.84756 8.89183 10.317 9.38658 10.317 10.0123V11.271Z",
    fill: "#2667B0",
    stroke: "#2667B0",
    strokeWidth: 0.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployerSearchCandidatesIconBlue);
export default __webpack_public_path__ + "static/media/employer_search_candidates_icon_blue.f3a6f6ab8ca7f04a0a4c1c6f47c088b9.svg";
export { ForwardRef as ReactComponent };